<div class="calc-page flex flex-col flex-1 min-h-0 gap-4 mt-4 overflow-auto">
  <div class="card calc-card flex flex-col flex-1 min-h-0 gap-4">
    <h2 class="calc-title">{{ 'CALCULOS.TITLE' | translate }}</h2>
    <div class="mt-4 mb-3">
      <div class="flex items-center gap-3">
        <label class="mb-0">
          <input
            type="radio"
            name="calculo"
            value="acumulados"
            (change)="cambiarCalculo('acumulados')"
            checked
          />
          {{ 'CALCULOS.MODE.ACCUMULATED' | translate }}
        </label>
        <label class="mb-0">
          <input
            type="radio"
            name="calculo"
            value="plagas"
            (change)="cambiarCalculo('plagas')"
          />
          {{ 'CALCULOS.MODE.PESTS' | translate }}
        </label>
      </div>
    </div>
    <div *ngIf="calculo === 'acumulados'">
      <form [formGroup]="datosForm" class="flex flex-col gap-4">
        <div
          class="filtros-superior grid gap-4 md:grid-cols-2 xl:grid-cols-4 items-end"
        >
          <div class="flex flex-col min-w-0">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'CALCULOS.FINCA' | translate }}</mat-label>
              <mat-select (selectionChange)="seleccionarFinca($event)">
                <mat-option disabled selected>{{
                  'CALCULOS.SELECT.FINCA' | translate
                }}</mat-option>
                <mat-option
                  *ngFor="let finca of fincas"
                  [value]="finca.idFinca"
                >
                  {{ finca.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-col min-w-0" *ngIf="isPrimerCalculo === false">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'CALCULOS.MODULE' | translate }}</mat-label>
              <mat-select formControlName="idModulo">
                <mat-option disabled selected>{{
                  'CALCULOS.SELECT.MODULE' | translate
                }}</mat-option>
                <mat-option
                  *ngFor="let modulo of modulos"
                  [value]="modulo.idModule"
                >
                  {{ modulo.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-col min-w-0" *ngIf="isPrimerCalculo === true">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'CALCULOS.MODULE' | translate }}</mat-label>
              <mat-select
                formControlName="idModulo"
                (selectionChange)="recogerDatos()"
              >
                <mat-option disabled selected>{{
                  'CALCULOS.SELECT.MODULE' | translate
                }}</mat-option>
                <mat-option
                  *ngFor="let modulo of modulos"
                  [value]="modulo.idModule"
                >
                  {{ modulo.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-col min-w-0">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'CALCULOS.PERIOD' | translate }}</mat-label>
              <mat-date-range-input
                [rangePicker]="calcRange"
                (dateChange)="onRangeChange($event.value)"
              >
                <input
                  matStartDate
                  formControlName="dateInitial"
                  placeholder="{{ 'CALCULOS.START' | translate }}"
                />
                <input
                  matEndDate
                  formControlName="dateFinal"
                  placeholder="{{ 'CALCULOS.END' | translate }}"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matSuffix
                [for]="calcRange"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #calcRange></mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="actions flex items-end min-w-0">
            <button
              type="button"
              mat-flat-button
              color="primary"
              class="calcular-btn"
              (click)="recogerDatos()"
            >
              {{ 'CALCULOS.CALCULATE' | translate }}
            </button>
          </div>
        </div>
        <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          <div class="flex flex-col min-w-0">
            <label>{{ 'CALCULOS.TEMP_MAX' | translate }}</label>
            <input
              type="number"
              class="form-control bg-light text-dark"
              disabled
              formControlName="temperaturaMaxima"
            />
          </div>

          <div class="flex flex-col min-w-0">
            <label>{{ 'CALCULOS.TEMP_MIN' | translate }}</label>
            <input
              type="number"
              class="form-control bg-light text-dark"
              disabled
              formControlName="temperaturaMinima"
            />
          </div>

          <div class="flex flex-col min-w-0">
            <label>{{ 'CALCULOS.TEMP_AVG' | translate }}</label>
            <input
              type="number"
              class="form-control bg-light text-dark"
              disabled
              formControlName="temperaturaMedia"
            />
          </div>

          <div class="flex flex-col min-w-0">
            <label>{{ 'CALCULOS.WIND_AVG' | translate }}</label>
            <input
              type="number"
              class="form-control bg-light text-dark"
              disabled
              formControlName="viento"
            />
          </div>
        </div>
        <div class="outputs-row grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          <div class="flex flex-col min-w-0">
            <label>{{ 'CALCULOS.PRECIPITATION' | translate }}</label>
            <input
              type="number"
              class="form-control bg-light text-dark"
              disabled
              formControlName="precipitacion"
            />
          </div>

          <div class="flex flex-col min-w-0">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'CALCULOS.FLOW_BY' | translate }}</mat-label>
              <mat-select
                formControlName="caudal"
                (selectionChange)="changeCaudal()"
              >
                <mat-option value="null">{{
                  'CALCULOS.FLOW_TOTAL' | translate
                }}</mat-option>
                <mat-option value="arbol">{{
                  'CALCULOS.FLOW_TREE' | translate
                }}</mat-option>
                <mat-option value="gotero">{{
                  'CALCULOS.FLOW_DRIPPER' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-col min-w-0">
            <label>{{ 'CALCULOS.ACCUMULATED_L' | translate }}</label>
            <input
              type="number"
              class="form-control bg-light text-dark"
              disabled
              formControlName="acumulado"
            />
          </div>

          <div class="flex flex-col min-w-0"></div>
        </div>
      </form>
    </div>

    <div *ngIf="calculo === 'plagas'">
      <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-5">
        <div class="flex flex-col min-w-0">
          <label>{{ 'CALCULOS.PEST' | translate }}</label>
          <select class="form-control">
            <option value="">{{ 'CALCULOS.SELECT.PEST' | translate }}</option>
            <option value="PRC">PRC</option>
          </select>
        </div>
        <div class="flex flex-col min-w-0">
          <label>{{ 'CALCULOS.FINCA' | translate }}</label>
          <select class="form-control">
            <option value="">{{ 'CALCULOS.SELECT.FINCA' | translate }}</option>
            <option value="Missana">Missana</option>
            <option value="Closa">Closa</option>
            <option value="Pulpi">Pulpi</option>
            <option value="Orihuela">Orihuela</option>
          </select>
        </div>

        <div class="flex flex-col min-w-0">
          <label>{{ 'CALCULOS.START_COUNT' | translate }}</label>
          <input type="date" class="form-control" />
        </div>

        <div class="flex flex-col min-w-0">
          <label>{{ 'CALCULOS.END_COUNT' | translate }}</label>
          <input type="date" class="form-control" />
        </div>

        <div class="flex flex-col min-w-0">
          <label>{{ 'CALCULOS.DEGREE_DAYS' | translate }}</label>
          <input
            type="number"
            class="form-control bg-light text-dark"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
</div>
